export default __webpack_public_path__ + "static/media/dataaxle.e2c25af7.csv";